module.exports = __webpack_public_path__ + "static/media/yo kun aakar hola.d5b19fd0.wav";